import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import { Provider as AppBridgeProvider } from "@shopify/app-bridge-react";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { BrowserRouter } from "react-router-dom";
import { QueryProvider } from "./components";
import en from "@shopify/polaris/locales/en.json";
import "@shopify/polaris/build/esm/styles.css";

const config = {
  apiKey: process.env.SHOPIFY_API_KEY,
  host: new URLSearchParams(location.search).get("host"),
  forceRedirect: true,
};

const root = createRoot(document.getElementById("shopify-app"));
root.render(
  <AppBridgeProvider config={config}>
    <PolarisProvider i18n={en}>
      <BrowserRouter>
        <QueryProvider>
          <App />
        </QueryProvider>
      </BrowserRouter>
    </PolarisProvider>
  </AppBridgeProvider>
);